/*global google*/
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import axios from "axios";

const containerStyle = {
  width: "140vh",
  height: "55vh",
};

const center = {
  lat: 23.023365067899896,
  lng: 72.50708810985088,
};

function SingleCropSurveyView() {
  const [map, setMap] = useState(null);
  const { state } = useLocation();
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate();
  const [cropSurveyData, setCropSurveyData] = useState("");
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
   googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE" 
})

  useEffect(() => {
    if (state) {
      setCropSurveyData(state.cropSurveyCode);
      setFlag(true);
    }
  });

  const onLoad = React.useCallback(function callback(map) {
    function firstFunction1() {
      return new Promise((resolve, reject) => {
        resolve(state.CropSurveyCode);
      });
    }

    async function secondFunction1() {
      const result = await firstFunction1();
      const polygonData = JSON.parse(result.polygonShape)
     
      map.setCenter(new google.maps.LatLng(polygonData[0].lat, polygonData[0].lng));
      let mmyPolygon = new window.google.maps.Polygon({
        paths: polygonData,
        strokeColor: "#FF0000",
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.1,
         content: `<div id="infoContent"> <span> <strong><b>Crop Survey Details - </b></strong> </span></br> <span><strong>Crop Area : </strong></span><span>${result.cropArea + " " + result.cropAreaUnitName}</span></br><span><strong>Crop Name : </strong></span><span>${result.cropName}</span></br><span><strong>Season Name : </strong></span><span>${result.seasonName}</span></br><span><strong>Farmer Name : </strong></span><span>${result.farmerName}</span></br><span><strong>Champion Farmer Name: </strong></span><span>${result.championFarmerName}</span></br></div>`,
      });
      mmyPolygon.setMap(map);
      let myInfoWindow = new google.maps.InfoWindow;
      mmyPolygon.addListener('mouseover', function (event) {
          mmyPolygon.setEditable(!mmyPolygon.getEditable());
          myInfoWindow.setContent(this.content);
          myInfoWindow.setPosition(event.latLng);
          myInfoWindow.open(map);
      });
      mmyPolygon.addListener('mouseout', function (event) {
          myInfoWindow.close();
      });
    
      
    }
    secondFunction1();
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded ? (
    <>
  
      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Crop Survey Details</h1>
           
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Crop Survey Details</li>
              <li className="breadcrumb-item active">View</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => navigate("/nature/cropsurvey")}
          >
            <FontAwesomeIcon icon={faArrowLeft} /> Back
          </button>
        </div>
        <section>
          <div className="card">
            <div className="card-body">
              <div className="container-fluid">
                <div class="formgroupss">
                  <h5 class="formgrouping">Crop Survey Details</h5>{" "}
                  <div class="row">
                    <div class="col-md-4">
                      <label>Crop Survey Code :</label>
                      {state.CropSurveyCode.cropSurveyCode}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Surveyor ID :</label>{" "}
                      {state.CropSurveyCode.surveyorID}
                    </div>
                    <div class="col-md-4">
                      <label>Farmer UID :</label>
                      {state.CropSurveyCode.farmerUID}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Farmer Name :</label>
                      {state.CropSurveyCode.farmerName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Season Name :</label>
                      {state.CropSurveyCode.seasonName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Year :</label> {state.CropSurveyCode.yearCode}{" "}
                    </div>

                    <div class="col-md-4">
                      <label>Remark :</label>
                      {state.CropSurveyCode.remark}{" "}
                    </div>
                    {/* <div class="col-md-4"><label>Surveyor ID :</label> {state.CropSurveyCode.farmerName1}</div> */}
                    <div class="col-md-4">
                      <label>Farmer Name :</label>
                      {state.CropSurveyCode.farmerUID}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>State Name :</label>
                      {state.CropSurveyCode.stateName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>District Name :</label>
                      {state.CropSurveyCode.districtName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Block Name :</label>{" "}
                      {state.CropSurveyCode.blockName}{" "}
                    </div>

                    <div class="col-md-4">
                      <label>Gram Panchayat Name:</label>
                      {state.CropSurveyCode.gramPanchayatName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Village Name :</label>{" "}
                      {state.CropSurveyCode.villageName}
                    </div>
                    <div class="col-md-4">
                      <label>Lok Sabha Name :</label>
                      {state.CropSurveyCode.lokSabhaName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Crop Name :</label>
                      {state.CropSurveyCode.cropName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>SubCrop Name :</label>{" "}
                      {state.CropSurveyCode.subCropName}{" "}
                    </div>

                    <div class="col-md-4">
                      <label>Champion Farmer Name :</label>
                      {state.CropSurveyCode.championFarmerName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Crop Area :</label>{" "}
                      {state.CropSurveyCode.cropArea +
                        " " +
                        state.CropSurveyCode.cropAreaUnitName}
                    </div>
                    {/* <div class="col-md-4"><label>Area Unit :</label>{state.CropSurveyCode.areaUnit} </div> */}
                    {/* <div class="col-md-4"><label>Mansoon Crop Code :</label>{state.CropSurveyCode.mansoonCropCode} </div> */}
                    <div class="col-md-4">
                      <label>Crop Name :</label>
                      {state.CropSurveyCode.cropName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>SubCrop Name :</label>{" "}
                      {state.CropSurveyCode.subCropName}{" "}
                    </div>
                  </div>
                </div>

                <h5 className="formgrouping">Crop Survey Images</h5>
                <div id="imageDiv">
                  <div>
                    <img
                      src={
                        "http://" +
                        state.CropSurveyCode.farmImagepath +
                        state.CropSurveyCode.farmImage
                      }
                      alt="Inspection Image"
                    />
                    <span> Latitude : {state.CropSurveyCode.surveyorLat}</span>
                    <span>
                      {" "}
                      Longitude : {state.CropSurveyCode.surveyorLong}
                    </span>
                  </div>
                </div>
                <h5 className="formgrouping">Crop Survey Map</h5>

                <div className="col-lg-3 dashboard">
                  <div className="card">
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={center}
                      zoom={18}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                      mapTypeId="satellite"
                    ></GoogleMap>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  ) : (
    <></>
  );
}

export default React.memo(SingleCropSurveyView);
